const differentiators = [
  {
    icon: 'ri-focus-3-line',
    title: 'Niche Expertise',
    desc: 'We serve restaurants, cafes, bars, skilled trades, small businesses, and nonprofits. That means every chart of accounts, every report, and every workflow is designed for your world from day one.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'True Local Focus',
    desc: 'We know the Richmond area — from the city\'s restaurant competition to Henrico and Chesterfield\'s growth corridors. Your books reflect your local reality.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Proactive Partnership',
    desc: 'We do not wait for you to ask questions. We flag anomalies, spot trends, and deliver actionable insights before problems become crises.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Modern Tech, Owner-Friendly Reports',
    desc: 'Cloud-based tools with clean dashboards you actually understand. No accounting jargon — just clear numbers that help you make better decisions.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Personalized & Responsive',
    desc: 'You work with a dedicated bookkeeper who knows your business. Same-day responses, scheduled check-ins, and in-person availability when you need it.',
  },
];

export default function ApproachSection() {
  return (
    <section id="approach" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              The Penland Difference
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl mx-auto leading-tight">
              Why Business Owners
              <span className="italic text-accent-600"> Choose Us</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
            {differentiators.map((diff, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 hover:border-accent-300/40 hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                  <i className={`${diff.icon} text-accent-600 text-2xl`} />
                </div>
                <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-3">
                  {diff.title}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {diff.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Bottom stat row */}
          <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {[
              { value: '4', label: 'Client Types Served', sub: 'Restaurants, Trades, Small Biz & Nonprofits' },
              { value: '3', label: 'Richmond-Area Locales', sub: 'Richmond, Henrico & Chesterfield' },
              { value: '30+', label: 'Min Discovery Call', sub: 'Free, No Obligation' },
              { value: 'Same-Day', label: 'Response Time', sub: 'Direct Bookkeeper Access' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <p className="font-heading text-2xl md:text-3xl text-accent-600 font-bold mb-1">
                  {stat.value}
                </p>
                <p className="text-primary-950 text-sm font-semibold">{stat.label}</p>
                <p className="text-foreground-500 text-xs mt-1">{stat.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}